.confirmModal {
  top: 32px;

  :global {
    div.ant-modal-body {
      padding: 24px;
    }
  }

  .actions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
    flex-direction: row;

    button:not(:last-child) {
      margin-right: 12px;
    }
  }
}
